import { createHighlighter } from 'shiki'
import { createJavaScriptRegexEngine } from 'shiki/engine/javascript'

type Highlighter = Awaited<ReturnType<typeof createHighlighter>>

let instance: Highlighter | null = null
let promise: Promise<Highlighter> | null = null

export function getShikiInstance(): Highlighter | null {
  return instance
}

export function getShikiHighlighter(): Promise<Highlighter> {
  if (!promise) {
    promise = createHighlighter({
      themes: ['github-light'],
      langs: ['json', 'xml'],
      engine: createJavaScriptRegexEngine()
    }).then((hl) => {
      instance = hl
      return hl
    })
  }

  return promise
}
